import { ReferenceField, UserResponse } from "../interfaces";

export const getFullName = (user: UserResponse): string => {
    return user.firstName + " " + user.lastName;
};

export const DashboardTypes = {
    Recruiter: "recruiter",
    Sales: "sales",
    Admin: "admin",
};

export const DashboardTypeOptions: ReferenceField[] = Object.entries(
    DashboardTypes,
).map(([label, value]) => {
    return {
        label: label,
        value: value,
    };
});
